// Links between pages: a real link (it opens in a new tab, and can be copied), which the app follows without a reload.
import type {AnchorHTMLAttributes,MouseEvent} from 'react';

export type Go=(id:string,params?:Record<string,string>)=>void;
/** The preview's switches (role, read-only, saved setup, emergency stop) ride along so a link opened in a new tab looks the same. */
const KEEP=['as','readonly','prefs','stop'];

export function pageHref(id:string,params:Record<string,string>={},search=location.search):string{
 const here=new URLSearchParams(search),next=new URLSearchParams();
 for(const k of KEEP){const v=here.get(k);if(v!==null)next.set(k,v);}
 next.set('admin','1');next.set('report',id);
 for(const [k,v] of Object.entries(params))next.set(k,v);
 return `?${next}`;
}

/** A plain click opens the page in the app; a click with a modifier key, or the middle button, opens a new tab. */
export const followLink=(e:MouseEvent,go:Go|undefined,id:string,params?:Record<string,string>)=>{
 if(!go||e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
 e.preventDefault();go(id,params);
};

export function PageLink({to,params,go,children,...rest}:{to:string;params?:Record<string,string>;go?:Go}&Omit<AnchorHTMLAttributes<HTMLAnchorElement>,'href'>){
 return <a {...rest} href={pageHref(to,params)} onClick={e=>{rest.onClick?.(e);followLink(e,go,to,params);}}>{children}</a>;
}
